// extracted by mini-css-extract-plugin
module.exports = {"assets":"Assets_assets__2_TIA","container":"Assets_container__1VVcw","checkbox-menu":"Assets_checkbox-menu__3KqqZ","token-titles":"Assets_token-titles__IWevE"};